import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-212fa2c0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsRadioButtonItem = _resolveComponent("FridgeDetailsRadioButtonItem")

  return (_openBlock(), _createBlock("div", {
    class: "fridgedetails-radiobutton",
    style: _ctx.styleOpacity
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(_component_FridgeDetailsRadioButtonItem, {
        class: "fridgedetails-radiobutton-item",
        key: item.index,
        index: item.index,
        text: item.text,
        selected: item.selected,
        onSelectIndex: _ctx.selectItem
      }, null, 8, ["index", "text", "selected", "onSelectIndex"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 4))
})